import { render, staticRenderFns } from "./CreateBlock.vue?vue&type=template&id=05684db2&scoped=true&"
import script from "./CreateBlock.vue?vue&type=script&lang=js&"
export * from "./CreateBlock.vue?vue&type=script&lang=js&"
import style0 from "./CreateBlock.vue?vue&type=style&index=0&id=05684db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05684db2",
  null
  
)

export default component.exports